import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import RadioButton from '../../shared/RadioButton/index.jsx';
import { BackArrow } from '../../shared/svgIcons.jsx';
import { incrementStep, decrementStep, setFormData } from '../redux/actions';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;

  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const RadioContainer = styled.div`
  border: 1px solid #6d6d6d;
  margin-bottom: 1rem;
  max-width: 35rem;
  min-width: 48%;
  padding: 1rem;
`;

const mapStateToProps = state => ({
  formData: state.formData,
});

const InvalidRegistrantType = ({ setFormData }) => {
  function clearValues() {
    setFormData({ registrantType: '' });
  }

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 3 - for this property"
        onClick={clearValues}
      >
        <BackArrow width="21" height="12" />
        <p>Back</p>
        <BackText>For this property, are you the...</BackText>
      </BackWrapper>
      <Header>Did you transfer your warranty?</Header>
      <p>The original owner of the shingles may transfer the warranty one time. </p>
      <p>
        For this warranty to transfer and the second Owner to obtain the benefits of this warranty, the second Owner
        must, within 60 days after the date of the real estate transaction, have transferred the warranty. Please review
        your warranty document to find the specific terms that apply to your shingles.
      </p>
      <p>
        "Current Warranty Documents" can be found here:{' '}
        <a href="https://www.owenscorning.com/en-us/roofing/warranty"> www.owenscorning.com/warranty.</a>{' '}
      </p>
      <p>
        For additional help, please contact us at{' '}
        <a href="mailto:answers.roofing@owenscorning.com.">answers.roofing@owenscorning.com.</a>{' '}
      </p>
    </StepWrapper>
  );
};

const Step3 = ({ incrementStep, decrementStep, formData, setFormData }) => {
  const validated = formData.registrantType;
  const showMessage = formData.registrantType == 'invalid_homeowner';

  return (
    <>
      {showMessage && <InvalidRegistrantType setFormData={setFormData} />}
      {!showMessage && (
        <StepWrapper>
          <BackWrapper
            data-track="form-back"
            data-track-form-name="Warranty Registration"
            data-track-form-step="step 3 - for this property"
            onClick={decrementStep}
          >
            <BackArrow width="21" height="12" />
            <h3>Back</h3>
            <BackText>What's your email?</BackText>
          </BackWrapper>
          <IntroMessage>Thanks for confirming your email!</IntroMessage>
          <Header>For this property, are you the...</Header>
          <RadioContainer>
            <RadioButton value="homeowner" fieldKey="registrantType" htmlAttributes={{}}>
              <label>Homeowner when shingles were installed (Re-Roof & New Construction)</label>
            </RadioButton>
          </RadioContainer>
          <RadioContainer>
            <RadioButton value="invalid_homeowner" fieldKey="registrantType" htmlAttributes={{}}>
              <label>Homeowner, but not when the shingles were installed</label>
            </RadioButton>
          </RadioContainer>
          <RadioContainer>
            <RadioButton value="contractor" fieldKey="registrantType" htmlAttributes={{}}>
              <label>Contractor who installed the roof</label>
            </RadioButton>
          </RadioContainer>
          <NextButton
            data-track="form-advance"
            data-track-form-name="Warranty Registration"
            data-track-form-step="step 3 - for this property"
            onClick={incrementStep}
            disabled={!validated}
          >
            Next
          </NextButton>
        </StepWrapper>
      )}
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  decrementStep: () => dispatch(decrementStep()),
  setFormData: hash => dispatch(setFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Step3);
